  import { AxiosResponse } from "axios";
import API from "core/networks/API";
import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  FETCH_LIST_FOLLOW_COMMUNITY_REQUEST,
  FETCH_LIST_TRENDING_COMMUNITY_REQUEST,
  FETCH_LIST_VIDEO_COMMUNITY_REQUEST,
  CREATE_COMMUNITY_REQUEST,
  fetchListFollowCommunityError,
  fetchListFollowCommunitySuccess,
  fetchListTrendingCommunityError,
  fetchListTrendingCommunitySuccess,
  fetchListVideoCommunityError,
  fetchListVideoCommunitySuccess,
  createCommunitySuccess,
  createCommunityError,
  FETCH_LIST_USER_POSTS_REQUEST,
  fetchListUserPostsError,
  fetchListUserPostsSuccess,
  FETCH_STATISTIC_CHANNEL_REQUEST,
  fetchStatisticChannelSuccess,
  fetchStatisticChannelError,
  fetchFollowStatusSuccess,
  UPDATE_FOLLOW_USER_REQUEST,
  updateFollowUserSuccess,
  updateFollowUserError,
  REPORT_POST_REQUEST,
  reportPostSuccess,
  reportPostError,

  FETCH_LIST_COMMENT_REQUEST,
  fetchListCommentSuccess,
  fetchListCommentError,
  RELOAD_LIST_COMMENT_REQUEST,
  reloadListCommentSuccess,

  CREATE_COMMENT_REQUEST,
  createCommentSuccess,
  createCommentError,

  DELETE_COMMENT_REQUEST,

  REPORT_COMMENT_REQUEST,
  reportCommentSuccess,
  reportCommentError,

  DELETE_POST_REQUEST,
  deletePostSuccess,
  deletePostError,
  REACTION_POST_REQUEST,
  reactionPostSuccess,
  reactionPostError,
  fetchDetailPostSuccess,
  fetchDetailPostError,
  FETCH_DETAIL_POST_REQUEST,
  REACTION_COMMENT_REQUEST,
  reactionCommentSuccess,
  reactionCommentError,
  fetchFollowStatusError,
  FETCH_FOLLOW_STATUS_REQUEST,
} from "./actions";
import {
  FetchListCommentAction,
  ReloadListCommentAction,
  CreateCommentAction,
  DeleteCommentAction,
  FetchDetailPostAction,
} from "./types";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import {
  API_GET_COMMUNITY_FOLLOWING,
  API_GET_COMMUNITY_TRENDING,
  API_GET_COMMUNITY_VIDEO,
  API_CREATE_COMMUNITY,
  API_GET_LIST_USER_POSTS,
  API_GET_STATISTIC_CHANNEL,
  API_FOLLOW_USER,
  API_REPORT_POST,
  API_REPORT_COMMENT,
  API_GET_LIST_COMMENT,
  API_CREATE_COMMENT,
  API_DELETE_POST,
  API_REACTION_POST,
  API_DELETE_COMMENT,
  API_GET_DETAIL_POST,
  API_REACTION_COMMENT,
} from "../api";

function* getListTrendingCommunity(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_COMMUNITY_TRENDING,
      action.payload
    );
    yield put(fetchListTrendingCommunitySuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error fetchDataHistory", error);
    yield put(fetchListTrendingCommunityError(error as Error));
  }
}

function* getListFollowCommunity(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_COMMUNITY_FOLLOWING,
      action.payload
    );
    yield put(fetchListFollowCommunitySuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error fetchDataHistory", error);
    yield put(fetchListFollowCommunityError(error as Error));
  }
}


function* getListVideoCommunity(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_COMMUNITY_VIDEO,
      action.payload
    );
    yield put(fetchListVideoCommunitySuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error fetchDataHistory", error);
    yield put(fetchListVideoCommunityError(error as Error));
  }
}

function* createCommunitySaga(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_CREATE_COMMUNITY,
      action.payload
    );
    yield put(createCommunitySuccess(response?.data));
  } catch (error: any) {
    yield put(createCommunityError(error.response.data as any));
  }
}

function* getListUserPostsCommunity(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_LIST_USER_POSTS.replace(':id', action.payload.id),
      action.payload
    );
    yield put(fetchListUserPostsSuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error getListUserPostsCommunity", error);
    yield put(fetchListUserPostsError(error as Error));
  }
}

function* getStatisticChannelCommunity(action: any) {
  try {
    const responseStatistic: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_STATISTIC_CHANNEL.replace(":id", action.payload.id),
      action.payload
    );
    yield put(fetchStatisticChannelSuccess(responseStatistic?.data?.data));
    // if(!action.payload?.isUserCurrent && action.payload?.auth) {
    //   // Gọi API follow user
    //   const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
    //     API.get,
    //     API_FOLLOW_USER.replace(":id", action.payload.id),
    //     action.payload
    //   );
    //   yield put(fetchFollowStatusSuccess(responseFollow?.data?.data));
    // }
  } catch (error: any) {
    console.log("error getStatisticChannelCommunity", error);
    yield put(fetchStatisticChannelError(error as Error));
  }
}

function* getStateFollowChannelCommunity(action: any) {
  try {
    if(!action.payload?.isUserCurrent && action.payload?.auth) {
      // Gọi API follow user
      const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
        API.get,
        API_FOLLOW_USER.replace(":id", action.payload.id),
        action.payload
      );
      yield put(fetchFollowStatusSuccess(responseFollow?.data?.data));
    }
  } catch (error: any) {
    console.log("error getStateFollowChannelCommunity", error);
    yield put(fetchFollowStatusError(error as Error));
  }
}

function* updateStatusFollowCommunity(action: any) {
  try {
    const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_FOLLOW_USER.replace(":id", action.payload),
      action.payload
    );
    console.log("responseFollow responseFollow", responseFollow);
    yield put(updateFollowUserSuccess(responseFollow?.data?.data));
  } catch (error: any) {
    console.log("error updateFollowUserError", error);
    yield put(updateFollowUserError(error as Error));
  }
}

function* reportPostCommunity(action: any) {
  try {
    const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_REPORT_POST.replace(":id", action.payload?.id),
      action.payload
    );
    yield put(reportPostSuccess(responseFollow?.data?.data));
  } catch (error: any) {
    console.log("error reportPostCommunity", error);
    yield put(reportPostError(error as Error));
  }
}

function* getListCommentSaga(action: FetchListCommentAction) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_LIST_COMMENT.replace(':post_id', action.payload.post_id),
      action.payload
    );
    yield put(fetchListCommentSuccess(response?.data?.data));
  } catch (error: any) {
    yield put(fetchListCommentError(error as Error));
  }
}

function* reloadListCommentSaga(action: ReloadListCommentAction) {
  try {
    const { callback, ...rest } = action.payload;
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_LIST_COMMENT.replace(':post_id', rest.post_id),
      rest
    );
    yield put(reloadListCommentSuccess(response?.data?.data));
    callback(response?.data?.data);
  } catch (error: any) {
    console.log("error reloadListCommentSaga", error);
  }
}

function* createCommentSaga(action: CreateCommentAction): any {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_CREATE_COMMENT.replace(':id', action.payload.id),
      action.payload
    );
    const user = yield select((state) => state.Auth.userInfo);
    yield put(createCommentSuccess({
      ...response?.data?.data,
      tab: action.payload.tab,
      user,
    }));
  } catch (error: any) {
    yield put(createCommentError(error as Error));
  }
}

function* deletePostCommunity(action: any) {
  try {
    const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_DELETE_POST.replace(":id", action.payload?.id),
      action.payload
    );
    yield put(deletePostSuccess(responseFollow?.data?.data));
  } catch (error: any) {
    console.log("error deletePostCommunity", error);
    yield put(deletePostError(error as Error));
  }
}

function* reactionPostCommunity(action: any) {
  try {
    const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_REACTION_POST.replace(":id", action.payload?.id),
      action.payload
    );
    yield put(reactionPostSuccess(responseFollow?.data?.data));
  } catch (error: any) {
    console.log("error reactionPostCommunity", error);
    yield put(reactionPostError(error as Error));
  }
}

function* deleteCommentSaga(action: DeleteCommentAction) {
  try {
    yield call(
      API.delete,
      API_DELETE_COMMENT
        .replace(':post_id', action.payload.post_id)
        .replace(':comment_id', action.payload.comment_id),
      action.payload
    );
  } catch (error: any) {
    console.log("error deleteCommentSaga", error);
  }
}

function* reportCommentCommunity(action: any) {
  try {
    const responseFollow: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.post,
      API_REPORT_COMMENT
        .replace(':post_id', action.payload.post_id)
        .replace(':comment_id', action.payload.comment_id),
      action.payload
    );
    yield put(reportCommentSuccess(responseFollow?.data?.data));
  } catch (error: any) {
    console.log("error reportCommentCommunity", error);
    yield put(reportCommentError(error as Error));
  }
}

function* getDetailPostSaga(action: FetchDetailPostAction) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_DETAIL_POST.replace(':id', action.payload.id),
      action.payload
    );
    yield put(fetchDetailPostSuccess(response?.data?.data));
  } catch (error: any) {
    yield put(fetchDetailPostError(error as Error));
  }
}

function* reactionCommentCommunity(action: any) {
  try {
    let urlApi = API_REACTION_COMMENT.replace(":post_id", action.payload?.id)
    urlApi =  urlApi.replace(":comment_id", action.payload?.comment_id)
    yield call(
      API.post,
      urlApi,
      action.payload
    );
    yield put(reactionCommentSuccess(action.payload));
  } catch (error: any) {
    console.log("error reactionCommentCommunity", error);
    yield put(reactionCommentError(error as Error));
  }
}

export default function* CommunitySaga() {
  yield takeLatest(FETCH_LIST_TRENDING_COMMUNITY_REQUEST, getListTrendingCommunity);
  yield takeLatest(FETCH_LIST_FOLLOW_COMMUNITY_REQUEST, getListFollowCommunity);
  yield takeLatest(FETCH_LIST_VIDEO_COMMUNITY_REQUEST, getListVideoCommunity);
  yield takeLatest(CREATE_COMMUNITY_REQUEST, createCommunitySaga);
  yield takeLatest(FETCH_LIST_USER_POSTS_REQUEST, getListUserPostsCommunity);
  yield takeLatest(FETCH_STATISTIC_CHANNEL_REQUEST, getStatisticChannelCommunity);
  yield takeLatest(UPDATE_FOLLOW_USER_REQUEST, updateStatusFollowCommunity);
  yield takeLatest(REPORT_POST_REQUEST, reportPostCommunity);

  yield takeLatest(FETCH_LIST_COMMENT_REQUEST, getListCommentSaga);
  yield takeLatest(RELOAD_LIST_COMMENT_REQUEST, reloadListCommentSaga);
  yield takeLatest(CREATE_COMMENT_REQUEST, createCommentSaga);
  yield takeLatest(DELETE_COMMENT_REQUEST, deleteCommentSaga);
  yield takeLatest(REPORT_COMMENT_REQUEST, reportCommentCommunity);
  
  yield takeLatest(DELETE_POST_REQUEST, deletePostCommunity);
  yield takeLatest(REACTION_POST_REQUEST, reactionPostCommunity);
  yield takeLatest(FETCH_DETAIL_POST_REQUEST, getDetailPostSaga);
  yield takeLatest(REACTION_COMMENT_REQUEST, reactionCommentCommunity);
  yield takeLatest(FETCH_FOLLOW_STATUS_REQUEST, getStateFollowChannelCommunity);
}
